import gql from 'graphql-tag';

const CAMPAIGN_ORDER_SESSIONS_ALL = gql`
  query CampaignOrderSessionsReportAll(
    $where: CampaignOrderSessionsWithEventsWhereInput
    $orderBy: CampaignOrderSessionsWithEventsOrderByInput
  ) {
    campaignOrderSessionsWithEventses(where: $where, orderBy: $orderBy) {
      key
      sessionId
      start
      end
      durationInSeconds
      pageViews
      totalImpressions
      landingPage
      exitPage
      deviceType
      attrMethod
      attrValue
      attrWindow
      sessionJourney {
        dateTime
        event
        url
      }
      impressions {
        eventId,
        media,
        impressionTime,
        impressionPublisherPlatform,
        impressionPublisherUrl,
        impressionPublisher,
        impressionPublisherMedia,
        impressionPubliserViewed
      }
    }
  }
`;

export default CAMPAIGN_ORDER_SESSIONS_ALL;
